import { cx } from 'cva';
import {
  SliderThumb as RACSliderThumb,
  type SliderThumbProps as RACSliderThumbProps,
} from 'react-aria-components/Slider';

import styles from './slider.module.css';

export type SliderThumbProps = RACSliderThumbProps;

export function SliderThumb(props: SliderThumbProps) {
  const { className, ...rest } = props;
  const classes = cx(styles.slider_thumb, className);
  return <RACSliderThumb className={classes} {...rest} />;
}
